import { Sparkles } from 'lucide-react'
import { wrapper, circle, icon, cursorPointer } from './style.css'
import Card from 'react-bootstrap/Card'
import { CheckIcon, InfoIcon, ArrowDownIcon } from 'lucide-react'
import { motion } from 'framer-motion'
import Button from 'react-bootstrap/Button'
import { DEMO_COMPANY, type Company } from './data'
import { CheckLineIcon, MousePointerClickIcon } from 'lucide-react'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Badge from 'react-bootstrap/Badge'
import Stack from 'react-bootstrap/Stack'

export default function Tutorial() {
  const navigate = useNavigate()
  const [company, setCompany] = useState<Company>(DEMO_COMPANY)
  return (
    <section className="d-flex flex-column justify-content-center align-items-center">
      <div className={wrapper}>
        <div className={circle}>
          <Sparkles className={icon} />
        </div>
      </div>
      <div>登録ありがとうございます！</div>
      <Card text="primary" border="primary" className="mb-4">
        <Card.Body>
          <Card.Title>興味ありとは？</Card.Title>
          <Card.Text>
            <CheckIcon className="me-1" />
            興味あり企業リストに保存されます
          </Card.Text>
          <Card.Text>
            <CheckIcon className="me-1" />
            企業にあなたの興味が通知されます
          </Card.Text>
          <Card.Text>
            <CheckIcon className="me-1" />
            その企業から面談や説明会のご連絡が届く場合があります
          </Card.Text>
        </Card.Body>
      </Card>
      <Card text="warning" border="warning" className="mb-4">
        <Card.Body>
          <Card.Title>練習モード</Card.Title>
          <Card.Text>
            <InfoIcon className="me-1" />
            こちらは練習用です。実際の企業に通知は送られません。
          </Card.Text>
        </Card.Body>
      </Card>
      <div className="mb-4">
        <motion.div
          animate={{ y: [0, -8, 0] }}
          transition={{ duration: 2, repeat: Infinity }}
          className="d-flex justify-content-center"
        >
          <ArrowDownIcon className="h-6 w-6 text-primary" />
        </motion.div>
        <p className="text-center text-muted">下の「興味あり」ボタンを押してみてください</p>
        <Card key={company.id} className={`my-4 ${cursorPointer}`}>
          <Card.Body>
            <Card.Title className="d-flex justify-content-between">{company.name}</Card.Title>
            <div>
              <ul>
                {company.summary?.map((summaryItem, idx) => (
                  <li key={idx} className="text-muted">
                    {summaryItem}
                  </li>
                ))}
              </ul>
            </div>
            <Stack direction="horizontal" gap={2} className="mb-2">
              {company.industries.map((industry) => (
                <Badge bg="secondary" key={industry.id}>
                  {industry.name}
                </Badge>
              ))}
            </Stack>
            <Card.Footer className="d-flex justify-content-center">
              <Button
                variant={company.bookmarked ? 'primary' : 'outline-secondary'}
                className="d-flex align-items-center"
                onClick={(e) => {
                  e.stopPropagation()
                  setCompany({ ...company, bookmarked: !company.bookmarked })
                  setTimeout(() => navigate('/login'), 2000)
                }}
              >
                {company.bookmarked ? (
                  <>
                    <CheckLineIcon className="me-1" />
                    チェック済み
                  </>
                ) : (
                  <>
                    <MousePointerClickIcon className="me-1" />
                    興味あり
                  </>
                )}
              </Button>
            </Card.Footer>
          </Card.Body>
        </Card>
        <p className="text-center text-muted">まずは上のカードで練習してみてください</p>
      </div>
    </section>
  )
}
